import { request } from "../index";

export function createNFSe(data) {
  return request({ url: "nfse/", data, method: "POST" });
}
export function getNFSe() {
  return request({ url: "nfse/" });
}
export function getConfig() {
  return request({ url: "nfse-config/" });
}
export function updateConfig(data) {
  return request({ url: `nfse-config/${data.id}/`, method: "PUT", data });
}
export function getService(id) {
  return request({ url: `services/${id}/` });
}
export function updateService(data) {
  return request({ url: `services/${data.id}/`, method: "PUT", data });
}
export function getServices() {
  return request({ url: `services/` });
}
export function createService(data) {
  return request({ url: `services/`, method: "POST", data });
}
export function verifyCompatibility() {
  return request({ url: `request-permission/`, params: { module: "nfse" } });
}
export function requestCompatibility(){
  request({ url: `request-permission/`, method: "POST", data:{"solicited_module": "nfse"} });
}
export function importNatOp() {
  return request({ url: "nfse-config/load-nat-op/", method: "POST"});
}
export function loadNatOp() {
  return request({ url: "nfse-config/get-nat-op/"});
}
export function importActivities() {
  return request({ url: "nfse-config/load-nat-op/", method: "POST"});
}
export function cancel(id){
  return request({ url: `nfse/${id}/`, method: "DELETE"});
}
export function aiReadService(data, params) {
  return request({ url: "nfse/ai-read-service/", method: "POST", data, params });
}
export function aiRegisterClient(data, params) {
  return request({ url: "nfse/ai-register-client/", method: "POST", data, params });
}
export function aiTranscribeAudio(data, params) {
  return request({ url: "nfse/ai-transcribe-audio/", method: "POST", data, params });
}


// WEBPACK FOOTER //
// ./src/api/nfse/index.js